import { render, staticRenderFns } from "./Usps.vue?vue&type=template&id=68b96a78&scoped=true&"
import script from "./Usps.vue?vue&type=script&lang=ts&"
export * from "./Usps.vue?vue&type=script&lang=ts&"
import style0 from "./Usps.vue?vue&type=style&index=0&id=68b96a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b96a78",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesUspsCheckmarkUsp: require('/var/www/packages/theme/components/molecules/Usps/CheckmarkUsp.vue').default})
